import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Select,
  Switch,
} from "antd";
import { APIConstants } from "../../../../../../Common/APIConstants";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  UnlockOutlined
} from "@ant-design/icons";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
const { Option } = Select;


const UserRegister = () => {
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [refetch, setRefetch] = useState(false);
  const [userData, setUserData] = useState([]);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const { isdarkMode } = mode;
  const [roles, setRoles] = useState([]);
   const [username, setUsername] = useState("");

  const handleUsernameChange = (e) => {
    const value = e.target.value.toLowerCase(); 
    console.log(value)
    setUsername(value);
  };
  const [updateUserData, setUpdateUserData] = useState(false);
    const [selectedUser,setSelectedUser]=useState(null)
  const showDrawer = () => setOpen(true);
  const onClose = () =>{
    form.resetFields()
    setOpen(false)
    setUpdateUserData(false)
};
  const showDrawer2 = () => setOpen2(true);
  const onClose2 = () =>{
    form2.resetFields()
    setOpen2(false)
    // setUpdateUserData(false)
};
  const getRoles = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_ROLES}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setRoles(res);
      }
    });
  };

  const getUserData = () => {
    const url = `${APIConstants.ELECTRICAL_GET_USER}`;
    makeRequest({
      type: APIConstants.GET,
      url,
    }).then((res) => {
      //console.log(res)
      if (res) setUserData(res);
    });
  };

  useEffect(() => {
    getRoles();
  }, []);
  useEffect(() => {
    getUserData();
  }, [refetch]);

  const handleNotification = (msg, type) => {
    message.open({ content: msg, type });
  };

  const deleteUser = (record) => {
    //console.log(record)
    const url = `${APIConstants.ELECTRICAL_DELETE_USER}?LoginID=${record.userId}`;
    makeRequest({
      type: APIConstants.DELETE,
      url,
    }).then((res) => {
      handleNotification(res?.message || "Deleted Successfully", "success");
      setRefetch(!refetch);
    });
  };

  const userCols = [
    // { headerName: "User ID", field: "UserId", width: 100, flex: 1 },
    { headerName: "First Name", field: "firstName",minWidth:190, flex: 1 },
    { headerName: "Last Name", field: "lastName",minWidth:190, flex: 1 },
    { headerName: "Phone", field: "mobileNumber",minWidth:190, flex: 1 },
    { headerName: "Email", field: "emailId",minWidth:190, flex: 1 },
    { headerName: "Username", field: "userName",minWidth:190, flex: 1 },
    { headerName: "Role Name", field: "roleName",minWidth:190, flex: 1 },
  {
  headerName: "Active",
  field: "isActive",
  minWidth: 190,
  flex: 1,
  cellRenderer: (params) => {
    //console.log(params) 
    const isActive = params.value === true || params.value === "true";
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            display: "inline-block",
            width: "13px",
            height: "13px",
            borderRadius: "50%",
            backgroundColor: isActive ? "green" : "red",
            marginTop:10
          }}
        />
        
        {/* <span>{isActive ? "True" : "False"}</span> */}
      </div>
    );
  },
}
,
    {
      headerName: "Created On",
      field: "createdDate",
      minWidth:190,
      flex: 1,
      valueFormatter: (params) => {
        if (!params.value) return "";
        return params.value.replace("T", " "); 
      }
    },
    {
      headerName: "Actions",
      minWidth:190,
      flex: 1,
      cellRenderer: (params) => (
        <div className="space-x-2">
          <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-green-400" 
           onClick={() => {
                          setOpen(true);
                          setUpdateUserData(true);
                          // //console.log(params.data.groupID);
                          //console.log(params.data);
                          setSelectedUser(params.data)
                          
                          form.setFieldsValue({
                            roleName: params.data.roleName,
                            userId: 2,
                            roleId: params.data.roleId,
                            userName: params.data.userName,
                            password: params.data.password,
                            firstName: params.data.firstName,
                            lastName:params.data.lastName,
                            mobileNumber: params.data.mobileNumber,
                            emailId: params.data.emailId,
                            createdDate:params.data.createdDate 
                          });
                        }}>
            <EditOutlined />
          </span>
          <span
  className="text-orange-500 bg-orange-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-orange-400" 
           onClick={() => {
                          setOpen2(true);
                          setSelectedUser(params.data)
                          
                        }}>
            <UnlockOutlined />
          </span>
          <Popconfirm
            title="Delete this user?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => deleteUser(params.data)}
            trigger="click"
          >
            <span
  className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400">
              <DeleteOutlined />
            </span>
          </Popconfirm>
        </div>
      ),
    },
  ];

   const onFinish = (values) => {
        //console.log(values);
        if (updateUserData) {
          //console.log(values);
          updateUsers(values);
        } else {
          form.resetFields();
          //console.log(values); 
          insertUser(values);
        }
      };
    
      const insertUser = (values) => {
        const body = {
      ...values,
      mobileNumber:String(values.mobileNumber)
      // roleID:values.roleId?.value,
      // isActive: values.isActive ? 1 : 0,
    };
    console.log(body)
    //console.log(values)

    const url = APIConstants.ELECTRICAL_INSERT_USER;
        //console.log(url);
        makeRequest({
          type: APIConstants.POST,
          url: url,
          body: body,
        }).then((res) => {
          setRefetch(!refetch);
          onClose();
          handleNotification(res?.message||"Successfully updated roles", "success");
          //console.log(res?.message);
        });
      };
      const updateUsers = (formValues) => {
        // console.log(formValues);
        const { roleId, ...rest } = formValues;
        //console.log(selectedUser)
        const body = {
          ...formValues,
          userId:selectedUser?.userId,
          // roleName: formValues.roleName,
          // applicationLevelRole:0,
        };
        // console.log(body);
        const url = `${APIConstants.ELECTRICAL_UPDATE_USER}`;
        //console.log(url);
    
        makeRequest({
          type: APIConstants.PUT,
          url: url,
          body: body,
        }).then((res) => {
          setRefetch(!refetch);
          onClose();
          form.resetFields();
          setUpdateUserData(false);
          handleNotification(res?.message, res?.message.includes('success')? "success":"error");
          // console.log(res);
        });
      };

  const onFinish2 = (values) => {
    console.log(values)
    console.log(selectedUser)
    const body = {
      emailID:selectedUser.emailId,
      newPassword: values.password ||'',
    };
    //console.log(body)
    //console.log(values)

    const url = APIConstants.UPDATE_PASSWORD_API;

    makeRequest({
      type: APIConstants.PUT,
      url,
      body,
    }).then((res) => {
      handleNotification(res?.message || "Password update successfully", "success");
      form2.resetFields();
      setOpen2(false);
      setRefetch(!refetch);
      setSelectedUser(null)
    });
  };

  return (
    <div
      className={`p-4 min-h-screen ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <h2
        className={`pb-4 text-left text-3xl font-[500] tracking-[1px] ${isdarkMode ? "text-white" : "text-black"}`}
      >
        User Registration
      </h2>

      <Card
        // title="User List"
        title={<div className={`${isdarkMode?'text-white':'text-black'}`}>
User List
        </div>}
        extra={
          <Button type="primary" onClick={showDrawer}>
            Add User +
          </Button>
        }
        className={`w-full rounded-md shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
        bodyStyle={{ padding: 0 }}
      >
        <div
          className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
          style={{
            "--ag-header-background-color": color.themeConfig.colorPrimary,
            "--ag-header-foreground-color": "#fff",
            "--ag-header-group-bg": color.themeConfig.colorPrimaryShade,
            height: "80vh",
            width: "100%",
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <AgGridReact
            rowData={userData}
            columnDefs={userCols}
            domLayout="normal"
            suppressHorizontalScroll={false}
          />
        </div>
      </Card>

      <CustomThemeDrawer
        title="User Registration"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <Form
          form={form2}
          layout="horizontal"
          onFinish={onFinish2}
          className="mt-4"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
        >
          <Form.Item
            // label="Password"
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Password
                </span>
              }
            name="password"
             rules={[
    { required: true, message: 'Password is required' },
    {
      pattern: /^[^\s]+$/,
      message: 'Spaces are not allowed. Only 0-9 and alphabets are allowed',
    },
  ]}
          >
            <Input.Password placeholder="Enter your password" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                } />
          </Form.Item>
         

          <div className="flex justify-between w-full gap-4 mt-6  absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </div>
        </Form>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="User Registration"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <Form
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          className="mt-4"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
        >
          <Form.Item
           label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  First Name
                </span>
              }
            // label="First Name"
            name="firstName"
            rules={[{ required: true, message: "Please enter last name" }]}
          >
            <Input  
            placeholder="Enter the first name" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }/>
          </Form.Item>
          <Form.Item
            // label="Last Name"
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Last Name
                </span>
              }
            name="lastName"
            rules={[{ required: true, message: "Please enter last name" }]}
          >
            <Input placeholder="Enter last name" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }/>
          </Form.Item>
          <Form.Item
          label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Phone Number
                </span>
              }
            // label="Phone Number"
            name="mobileNumber"
            rules={[
              {
                required: true,
                message: "Please enter your mobile number",
              },
              {
                pattern: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit mobile number",
              },
            ]}
          >
            <InputNumber placeholder="Enter Mobile  number" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                style={{width:"100%"}}/>
          </Form.Item>
          <Form.Item
            name="emailId"
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Email
                </span>
              }
            // label="Email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input 
            disabled={updateUserData} className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                } placeholder="you@example.com"  />
          </Form.Item>
          <Form.Item
            // label="Username"
            
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Username
                </span>
              }
            name="userName"
            rules={[
          { required: true, message: "Please input your username!" },
          {
            pattern: /^[a-z0-9]*$/,
            message: "Only lowercase letters and 0-9 are allowed",
          },
        ]} 
          >
            <Input 
            disabled={updateUserData}
            value={username}
          onChange={handleUsernameChange}
             placeholder="Enter username" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }/>
          </Form.Item>
          {
            !updateUserData&&
          <Form.Item
            // label="Password"
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Password
                </span>
              }
            name="password"
            rules={[
    { required: true, message: 'Password is required' },
    {
      pattern: /^[^\s]+$/,
      message: 'Spaces are not allowed. Only 0-9 , special characters and alphabets are allowed',
    },
  ]}
          >
            <Input.Password placeholder="Enter your password" className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                } />
          </Form.Item>
          }
          <Form.Item
            // label="Role"
            label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Role
                </span>
              }
            name="roleId"
            rules={[
              {
                required: true,
                message: "Please select a role!",
              },
            ]}
          >
            <Select
              // value={selectedValue}
              // onChange={handleChange}
              // style={{ width: 200 }}
              // labelInValue
              placeholder="Select a converter"
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background"
                  : "light-mode-dropdown"
              }
              className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
            >
              {roles.map((i) => (
                            <Option key={i.roleId} value={i.roleId}>
                              {i.roleName}
                            </Option>
                          ))}
            </Select>
          </Form.Item>
          {/* <Form.Item
            label="Active"
            name="isActive"
            rules={[
              {
                required: true,
                message: "Please select a isActive!",
              },
            ]}
          >
           <Select
  labelInValue
  placeholder="Select status"
  dropdownClassName={
    isdarkMode
      ? "select-dropdown-background"
      : "light-mode-dropdown"
  }
  className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80`}
>
  <Option value="true">true</Option>
  <Option value="false">false</Option>
</Select>

          </Form.Item> */}

          <div className="flex justify-between w-full gap-4 mt-6  absolute bottom-0 right-0 p-4">
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {updateUserData?'Update':'Add'}
            </Button>
          </div>
        </Form>
      </CustomThemeDrawer>
    </div>
  );
};

export default UserRegister;

// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { Button, Card, Form, message, Popconfirm, Select } from "antd";
// import { APIConstants } from "../../../../../../Common/APIConstants";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   QuestionCircleOutlined,
// } from "@ant-design/icons";
// import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
// import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

// const UserRegister = () => {
//   const mode = useSelector((state) => state.darkMode);
//   const color = useSelector((state) => state.ThemeChange);
//   const [open, setOpen] = useState(false);
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const [refetch, setRefetch] = useState(false);
//   const [roles, setRoles] = useState([]);
//   const [form] = Form.useForm();
// //   //console.log(color);
//   const { isdarkMode } = mode;
//   const showDrawer = () => {
//     setOpen(true);
//   };

//   const onClose = () => {
//     // form1.resetFields()
//     setOpen(false);
//   };
//   const getRoles = () => {
//     // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
//     const url = `${APIConstants.ELECTRICAL_GET_DASHBOARD_METER_DETAILS}`;
//     //console.log(url);

//     makeRequest({
//       type: APIConstants.GET,
//       url: url,
//       // body:formValues
//     }).then((res) => {
//       //console.log(res);
//       if (res) {
//         setRoles(res);
//       }
//     });
//   };
//   useEffect(() => {
//     getRoles();
//   }, []);

//   const handleNotification = (msg, type) => {
//     message.open({
//       content: `${msg}`,
//       type: type,
//     });
//   };

//   const roleCols = [
//     { headerName: "Role ID", field: "rolesID", width: 100,flex:1 },
//     { headerName: "Roles", field: "roles", width: 110, flex: 1 },
//     { headerName: "Created On ", field: "createdON", width: 110, flex: 1 },
//     { headerName: "Active ", field: "isActive", width: 110, flex: 1 },
//     {
//       headerName: "Actions",
//       width: 80,
//       flex: 1,
//       cellRenderer: (params) => {
//         return (
//           <div className="space-x-2">
//             <Button
//                     //   onClick={() => {
//                     //     params.data.actions.update(params.data);
//                     //   }}
//                     >
//                       <EditOutlined />
//                     </Button>

//             <Popconfirm
//               title="Are you sure to delete this Converter"
//               // description="Are you sure to delete this Converter Configuration?"
//               icon={<QuestionCircleOutlined style={{ color: "red" }} />}
//               onConfirm={() => deleteRoles(params.data)}
//               trigger="click"
//             >
//               <Button className="text-red-500">
//                 <DeleteOutlined />
//               </Button>
//             </Popconfirm>
//           </div>
//         );
//       },
//     },
//   ];

//   const deleteRoles = (formValues) => {
//     //console.log(formValues);

//     const body = {
//       groupID: formValues.groupID,
//     };

//     const url = `${APIConstants.ELECTRICAL_DELETE_DASHBOARD_METER_DETAILS}?AutoID=${formValues.autoID}`;

//     //console.log(url);
//     //console.log(body);

//     // makeRequest({
//     //   type: APIConstants.DELETE,
//     //   url: url,
//     //   body: body,
//     // }).then((res) => {
//     //   //console.log(res);
//     //   // onClose2();
//     //   setRefetch(!refetch);
//     //   handleNotification(res.message, "error");
//     // });
//   };
//   return (
//     <div
//       className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
//     >
//       <div>
//         <h2
//           className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
//             isdarkMode ? "text-white" : "text-black"
//           }`}
//         >
//           User Registration
//         </h2>

//         <div className="flex gap-4 h-[90vh]">
//           {/*  User registration */}
//           <Card
//             title={
//               <span className={isdarkMode ? "text-white" : "text-black"}>
//                 User Registration
//               </span>
//             }
//             extra={
//               <Button type="primary" onClick={() => showDrawer()}>
//                 Add +
//               </Button>
//             }
//             className={`w-full rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
//             bodyStyle={{ padding: 0 }}
//           >
//             <div
//               className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
//               style={{
//                 "--ag-header-background-color": color.themeConfig.colorPrimary,
//                 "--ag-header-foreground-color": "#fff",
//                 "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
//                 height: "80vh",
//                 width: "100%",
//                 overflowY: "auto",
//               }}
//             >
//               <AgGridReact
//                 rowData={roles}
//                 columnDefs={roleCols}
//                 domLayout="normal"
//               />
//             </div>
//           </Card>
//         </div>
//       </div>

//       <CustomThemeDrawer
//         title="Close"
//         showDrawer={showDrawer}
//         open={open}
//         onClose={onClose}
//       >
//         <div className="flex flex-col gap-6 mt-2">
//           <Form
//             form={form}
//             name="Group-add-form"
//             // className="font-bold"
//             layout="horizontal"
//             style={{
//               maxWidth: 600,
//             }}
//             labelCol={{
//               span: 8,
//               offset: 0,
//             }}
//             labelAlign="left"
//             // onFinish={onFinish}
//           >
//             <Form.Item
//               label="Converter Name"
//               name="converterID"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select a converter!",
//                 },
//               ]}
//             >
//               <Select
//                 // value={selectedValue}
//                 // onChange={handleConverter}
//                 // style={{ width: 200 }}
//                 labelInValue
//                 placeholder="Select a group"
//                 dropdownClassName={
//                   isdarkMode
//                     ? "select-dropdown-background"
//                     : "light-mode-dropdown"
//                 }
//                 className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
//               >
//                 {/* {groupData.map((i) => (
//                   <Option key={i.siteID} value={i.siteName}>
//                     {i.siteName}
//                   </Option>
//                 ))} */}
//               </Select>
//             </Form.Item>
//             <Form.Item
//               label="Meter Name"
//               name="meterID"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select a meter!",
//                 },
//               ]}
//             >
//               <Select
//                 // value={selectedValue}
//                 // onChange={handleChange}
//                 // style={{ width: 200 }}
//                 labelInValue
//                 placeholder="Select a converter"
//                 dropdownClassName={
//                   isdarkMode
//                     ? "select-dropdown-background"
//                     : "light-mode-dropdown"
//                 }
//                 className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
//               >
//                 {/* {metersData.map((i) => (
//                   <Option key={i.meterid} value={i.metername}>
//                     {i.metername}
//                   </Option>
//                 ))} */}
//               </Select>
//             </Form.Item>
//           </Form>

//           <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
//             <Button onClick={onClose} className="">
//               Cancel
//             </Button>
//             <Button type="primary" onClick={() => form.submit()}>
//               Add
//             </Button>
//           </div>
//         </div>
//       </CustomThemeDrawer>
//     </div>
//   );
// };

// export default UserRegister;
